import { REALTIME_CONNECTION_STATE_CHANGE, DATA_OBJECT_DELETED_SUCCESS } from "~/store/action_types";

export const realTimeConnectionStateChange = (states) => {
  return {
    type: REALTIME_CONNECTION_STATE_CHANGE,
    states,
  };
};

export const deleteDataObject = (id, type) => {
  return {
    type: DATA_OBJECT_DELETED_SUCCESS,
    id,
    objectType: type,
  };
};
